import React from 'react';
import classNames from 'classnames';
import { RuleExecutionResult } from '@decisions/server/DecisionsFramework/Design/Flow/Service/Debugging/Events';
import { RuleStepEvaluation } from '@decisions/server/DecisionsFramework/Design/Flow/Service/Debugging/DebugData/RuleStepEvaluation';
import './StepEvaluation.less';

export interface IStepEvaluationProps {
  /**
   * @default false
   */
  showBeyondPass?: boolean;
  index?: number;
  evaluation: RuleStepEvaluation;
}

const getClassName = (executionResult: RuleExecutionResult) =>
  classNames('dpc-rule-step-evaluation', {
    'dpc-rule-step-evaluation--success': executionResult === RuleExecutionResult.Success,
    'dpc-rule-step-evaluation--failure': executionResult === RuleExecutionResult.Failure,
  });

const beyondPathPrompt = 'Evaluation only for display. Not considered for rule result.';

/**
 * Shows step evaluation result inline for sampling/unit tests/debugger
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function StepEvaluation({ evaluation, showBeyondPass = false, index }: IStepEvaluationProps) {
  return (
    <div className={getClassName(evaluation.Result)} title={getEvaluationTitle(evaluation)}>
      {index != null && <span className="dpc-rule-step-evaluation__number">{index}. </span>}
      {evaluation.WithNot && <span className="dpc-rule-step-evaluation__not">not</span>}
      {evaluation.Anchor && <span className="dpc-rule-step-evaluation__anchor">{evaluation.Anchor}</span>}
      {evaluation.Verb && <span className="dpc-rule-step-evaluation__verb">{evaluation.Verb}</span>}
      {evaluation.Values && <span className="dpc-rule-step-evaluation__values">{evaluation.Values}</span>}
      {!showBeyondPass && evaluation.BeyondThePath && (
        <span className="dpc-rule-step-evaluation__beyond-path" title={beyondPathPrompt}>
          ✱
        </span>
      )}
    </div>
  );
}

function getEvaluationTitle(evaluation: RuleStepEvaluation) {
  return `${evaluation.WithNot ? 'not ' : ''}${evaluation.Anchor ?? ''} ${evaluation.Verb} ${evaluation.Values ?? ''}`;
}
